import { ReactElement } from 'react';
import {
  attachComponentData,
  getComponentData,
} from '@backstage/core-plugin-api';

const FORWARDED_DATA_KEYS = ['core.plugin', 'core.mountPoint'];

/**
 * Wraps a routable page element (e.g. `<CatalogIndexPage />`) while keeping it
 * discoverable by `convertLegacyAppRoot`.
 *
 * The NFS compat layer reads a route's plugin and routeRef from the `element`
 * prop of the `<Route>` itself, not from its descendants. A plain wrapper such
 * as `<RequireFeatureFlag><Page /></RequireFeatureFlag>` hides that data, so
 * the page ends up on the orphan plugin without its routeRef and fails with
 * "Routable extension component ... was not discovered in the app element
 * tree" (or "No path for routeRef"). This forwards the data onto the wrapper.
 */
export function wrapRoutable(
  routable: ReactElement,
  wrap: (inner: ReactElement) => ReactElement,
): ReactElement {
  const Wrapped = () => wrap(routable);
  for (const key of FORWARDED_DATA_KEYS) {
    const data = getComponentData(routable, key);
    if (data !== undefined) {
      attachComponentData(Wrapped, key, data);
    }
  }
  return <Wrapped />;
}
